<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" :disable-backdrop-click="false">
    <div class="mx-auto w-full max-w-5xl">
      <BaseCard>
        <BaseCardHeader>
          {{ facebookCampaign ? facebookCampaign.name : 'Facebook' }} Campaign Overview
        </BaseCardHeader>
        <BaseCardBody>
          <Loader v-if="fetching" />
          <Overview v-else :facebook-campaign="facebookCampaign" />
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import { facebookCampaignMethods } from '@/store/adminHelper';
import facebookCampaignsClient from '@/api/clients/facebookCampaignsClient';
import Overview from './Overview.vue';

export default {
  components: {
    Overview,
  },
  props: {
    facebookCampaignId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      fetching: false,
      facebookCampaign: null,
    };
  },
  created() {
    this.fetchFacebookCampaign();
  },
  methods: {
    ...facebookCampaignMethods,
    async fetchFacebookCampaign() {
      this.fetching = true;
      try {
        const response = await facebookCampaignsClient.getFacebookCampaign(
          this.facebookCampaignId,
          {
            include: 'lifetimeReport,dailyReports',
          }
        );

        this.facebookCampaign = response.data;
      } catch (error) {
        //
      } finally {
        this.fetching = false;
      }
    },
  },
};
</script>
